import React from 'react'

const Dsw5 = () => {
    return (
        <div className='container'>
            <h1>Largest Sum Contiguous Subarray</h1>
            <p>Write an efficient program to find the sum of contiguous subarray within a one-dimensional array of numbers that has the largest sum. </p>
            <p><strong>Kadane’s Algorithm:</strong></p>
            <pre className='containers'>Initialize: <br />
    max_so_far = INT_MIN <br />
    max_ending_here = 0 <br />
 <br />
Loop for each element of the array <br />
  (a) max_ending_here = max_ending_here + a[i] <br />
  (b) if(max_so_far &lt; max_ending_here) <br />
            max_so_far = max_ending_here <br />
  (c) if(max_ending_here &lt; 0) <br />
            max_ending_here = 0 <br />
return max_so_far</pre> <br />
<p><strong>Explanation:</strong>&nbsp;<br/>
The simple idea of Kadane’s algorithm is to look for all positive contiguous segments of the array (max_ending_here is used for this). And keep track of maximum sum contiguous segment among all positive segments (max_so_far is used for this). Each time we get a positive-sum compare it with max_so_far and update max_so_far if it is greater than max_so_far&nbsp;</p>
<pre className='containers'>    Lets take the example: <br />
   {` {-2, -3, 4, -1, -2, 1, 5, -3}`} <br />
 <br />
    max_so_far = max_ending_here = 0 <br />
 <br />
    for i=0,  a[0] =  -2 <br />
    max_ending_here = max_ending_here + (-2) <br />
    Set max_ending_here = 0 because max_ending_here &lt; 0 <br />
 <br />
    for i=1,  a[1] =  -3 <br />
    max_ending_here = max_ending_here + (-3) <br />
    Set max_ending_here = 0 because max_ending_here &lt; 0 <br />
 <br />
    for i=2,  a[2] =  4 <br />
    max_ending_here = max_ending_here + (4) <br />
    max_ending_here = 4 <br />
    max_so_far is updated to 4 because max_ending_here greater  <br />
    than max_so_far which was 0 till now <br />
 <br />
    for i=3,  a[3] =  -1 <br />
    max_ending_here = max_ending_here + (-1) <br />
    max_ending_here = 3 <br />
 <br />
    for i=4,  a[4] =  -2 <br />
    max_ending_here = max_ending_here + (-2) <br />
    max_ending_here = 1 <br />
 <br />
    for i=5,  a[5] =  1 <br />
    max_ending_here = max_ending_here + (1) <br />
    max_ending_here = 2 <br />
 <br />
    for i=6,  a[6] =  5 <br />
    max_ending_here = max_ending_here + (5) <br />
    max_ending_here = 7 <br />
    max_so_far is updated to 7 because max_ending_here is  <br />
    greater than max_so_far <br />
 <br />
    for i=7,  a[7] =  -3 <br />
    max_ending_here = max_ending_here + (-3) <br />
    max_ending_here = 4</pre>

                   <div class="tabs">
    <input type="radio" name="tab" id="tab1"/>
    <label for="tab1">CPP</label>
    <input type="radio" name="tab" id="tab2"/>
    <label for="tab2">Java </label>
    <input type="radio" name="tab" id="tab3"/>
    <label for="tab3">Python</label>
  
    <div class="tab-content-wrapper">
      <div id="tab-content-1" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code
            class="comments">// C++ program to print largest contiguous array sum</code></div>
    <div class="line number2 index1 alt1"><code class="preprocessor">#include&lt;iostream&gt;</code></div>
    <div class="line number3 index2 alt2"><code class="preprocessor">#include&lt;climits&gt;</code></div>
    <div class="line number4 index3 alt1"><code class="keyword bold">using</code> <code
            class="keyword bold">namespace</code> <code class="plain">std;</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code class="color1 bold">int</code> <code
            class="plain">maxSubArraySum(</code><code class="color1 bold">int</code> <code
            class="plain">a[], </code><code class="color1 bold">int</code> <code class="plain">size)</code></div>
    <div class="line number7 index6 alt2"><code class="plain">&#123;</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">max_so_far = INT_MIN, max_ending_here = 0;</code></div>
    <div class="line number9 index8 alt2">&nbsp;</div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(</code><code class="color1 bold">int</code> <code
            class="plain">i = 0; i &lt; size; i++)</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">max_ending_here = max_ending_here + a[i];</code></div>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(max_so_far &lt; max_ending_here)</code></div>
    <div class="line number14 index13 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">max_so_far = max_ending_here;</code></div>
    <div class="line number15 index14 alt2">&nbsp;</div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(max_ending_here &lt; 0)</code></div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">max_ending_here = 0;</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">max_so_far;</code></div>
    <div class="line number20 index19 alt1"><code class="plain">&#125;</code></div>
    <div class="line number21 index20 alt2">&nbsp;</div>
    <div class="line number22 index21 alt1"><code class="comments">/*Driver program to test maxSubArraySum*/</code>
    </div>
    <div class="line number23 index22 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number24 index23 alt1"><code class="plain">&#123;</code></div>
    <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">a[] = &#123;-2, -3, 4, -1, -2, 1, 5, -3&#125;;</code></div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">n = </code><code class="keyword bold">sizeof</code><code
            class="plain">(a)/</code><code class="keyword bold">sizeof</code><code class="plain">(a[0]);</code></div>
    <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">max_sum = maxSubArraySum(a, n);</code></div>
    <div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; </code><code class="string">"Maximum contiguous sum is "</code> <code
            class="plain">&lt;&lt; max_sum;</code></div>
    <div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number30 index29 alt1"><code class="plain">&#125;</code></div>
</div>
      </div>
      <div id="tab-content-2" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="keyword">import</code> <code class="plain">java.io.*;</code>
    </div>
    <div class="line number2 index1 alt1"><code
            class="comments">// Java program to print largest contiguous array sum</code></div>
    <div class="line number3 index2 alt2"><code class="keyword">import</code> <code class="plain">java.util.*;</code>
    </div>
    <div class="line number4 index3 alt1">&nbsp;</div>
    <div class="line number5 index4 alt2"><code class="keyword">class</code> <code class="plain">Kadane</code></div>
    <div class="line number6 index5 alt1"><code class="plain">&#123;</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
            class="plain">main (String[] args)</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number9 index8 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">[] a = &#123;-</code><code class="value">2</code><code
            class="plain">, -</code><code class="value">3</code><code class="plain">, </code><code
            class="value">4</code><code class="plain">, -</code><code class="value">1</code><code
            class="plain">, -</code><code class="value">2</code><code class="plain">, </code><code
            class="value">1</code><code class="plain">, </code><code class="value">5</code><code
            class="plain">, -</code><code class="value">3</code><code class="plain">&#125;;</code></div>
    <div class="line number10 index9 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"Maximum contiguous sum is "</code> <code
            class="plain">+</code></div>
    <div class="line number11 index10 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">maxSubArraySum(a));</code></div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number13 index12 alt2">&nbsp;</div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">static</code> <code class="keyword">int</code> <code
            class="plain">maxSubArraySum(</code><code class="keyword">int</code> <code class="plain">a[])</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">size = a.length;</code></div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code
            class="plain">max_so_far = Integer.MIN_VALUE, max_ending_here = </code><code class="value">0</code><code
            class="plain">;</code></div>
    <div class="line number18 index17 alt1">&nbsp;</div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">for</code> <code class="plain">(</code><code class="keyword">int</code> <code
            class="plain">i = </code><code class="value">0</code><code class="plain">; i &lt; size; i++)</code></div>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">max_ending_here = max_ending_here + a[i];</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(max_so_far &lt; max_ending_here)</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">max_so_far = max_ending_here;</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(max_ending_here &lt; </code><code class="value">0</code><code
            class="plain">)</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">max_ending_here = </code><code class="value">0</code><code class="plain">;</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number27 index26 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="plain">max_so_far;</code></div>
    <div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number29 index28 alt2"><code class="plain">&#125;</code></div>
</div>
        </div>
      <div id="tab-content-3" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code
            class="comments"># Python program to find maximum contiguous subarray</code></div>
    <div class="line number2 index1 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number3 index2 alt2"><code
            class="comments"># Function to find the maximum contiguous subarray</code></div>
    <div class="line number4 index3 alt1"><code class="keyword">from</code> <code class="plain">sys </code><code
            class="keyword">import</code> <code class="plain">maxint</code></div>
    <div class="line number5 index4 alt2"><code class="keyword">def</code> <code
            class="plain">maxSubArraySum(a,size):</code></div>
    <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
    </div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">max_so_far </code><code class="keyword">=</code> <code class="keyword">-</code><code
            class="plain">maxint </code><code class="keyword">-</code> <code class="value">1</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">max_ending_here </code><code class="keyword">=</code> <code class="value">0</code></div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;
    </div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">for</code> <code class="plain">i </code><code class="keyword">in</code> <code
            class="functions">range</code><code class="plain">(</code><code class="value">0</code><code
            class="plain">, size):</code></div>
    <div class="line number11 index10 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">max_ending_here </code><code class="keyword">=</code> <code
            class="plain">max_ending_here </code><code class="keyword">+</code> <code class="plain">a[i]</code></div>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(max_so_far &lt; max_ending_here):</code></div>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">max_so_far </code><code class="keyword">=</code> <code class="plain">max_ending_here</code>
    </div>
    <div class="line number14 index13 alt1">&nbsp;</div>
    <div class="line number15 index14 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">max_ending_here &lt; </code><code class="value">0</code><code
            class="plain">:</code></div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">max_ending_here </code><code class="keyword">=</code> <code class="value">0</code>&nbsp;&nbsp;
    </div>
    <div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="plain">max_so_far</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number19 index18 alt2"><code class="comments"># Driver function to check the above function</code>
    </div>
    <div class="line number20 index19 alt1"><code class="plain">a </code><code class="keyword">=</code> <code
            class="plain">[</code><code class="keyword">-</code><code class="value">13</code><code
            class="plain">, </code><code class="keyword">-</code><code class="value">3</code><code
            class="plain">, </code><code class="keyword">-</code><code class="value">25</code><code
            class="plain">, </code><code class="keyword">-</code><code class="value">20</code><code
            class="plain">, </code><code class="keyword">-</code><code class="value">3</code><code
            class="plain">, </code><code class="keyword">-</code><code class="value">16</code><code
            class="plain">, </code><code class="keyword">-</code><code class="value">23</code><code
            class="plain">, </code><code class="keyword">-</code><code class="value">12</code><code
            class="plain">, </code><code class="keyword">-</code><code class="value">5</code><code
            class="plain">, </code><code class="keyword">-</code><code class="value">22</code><code
            class="plain">, </code><code class="keyword">-</code><code class="value">15</code><code
            class="plain">, </code><code class="keyword">-</code><code class="value">4</code><code
            class="plain">, </code><code class="keyword">-</code><code class="value">7</code><code
            class="plain">]</code></div>
    <div class="line number21 index20 alt2"><code class="functions">print</code> <code
            class="string">"Maximum contiguous sum is"</code><code class="plain">, maxSubArraySum(a,</code><code
            class="functions">len</code><code class="plain">(a))</code></div>
    <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number23 index22 alt2"><code class="comments">#This code is contributed by _Devesh Agrawal_</code>
    </div>
</div>
        </div>
     
       
    
        </div>
  </div>
        </div>
    )
}

export default Dsw5
